import { gql } from "apollo-boost";

export const GET_VEHICLE = gql`
  query GetVehicle($vehicleId: String!) {
    vehicle(id: $vehicleId) {
      id
      licencePlate
      vin
      make
      model
      colour
      year
      bodyType
      fuelType
      imageUrl
      status
      vehicleState {
        id
        odometerReading
        fuelStatus
        batteryStatus
        updatedAt
      }
      branch
      branchId
      branchDetails {
        id
      }
      activeVehicleDamages {
        id
        damages {
          damageType
          damageArea
          descriptions
        }
      }
      activeBookingSchedule {
        id
        startDate
        endDate
        booking {
          id
          referenceNumber
          pickupDateTime
          dropoffDateTime
          status
          pickupServiceLocation {
            name
          }
          dropoffServiceLocation {
            name
          }
          customer {
            id
            firstName
            lastName
            email
            phoneNumber {
              phone
              country
            }
          }
          businessCustomer {
            id
            businessName
            billing {
              email
              phoneNumber {
                phone
                country
              }
            }
          }
        }
      }
    }
  }
`;


